export enum CountriesTypes {
  ADD_COUNTRY_START = 'ADD_COUNTRY_START',
  ADD_COUNTRY_FAILED = 'ADD_COUNTRY_FAILED',
  ADD_COUNTRY_SUCCESS = 'ADD_COUNTRY_SUCCESS',
  GET_COUNTRIES_START = 'GET_COUNTRIES_START',
  GET_COUNTRIES_FAILED = 'GET_COUNTRIES_FAILED',
  GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS',
}
